export default __webpack_public_path__ + "static/media/trophy-icon.90293bc5.svg";